var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c("div", { staticClass: "content c-top" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c("breadcrumb-search", {
              attrs: { breadcrumbSearch: _vm.searchList },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "margin-top": "22px", "padding-bottom": "24px" } },
          [
            _c(
              "el-form",
              { attrs: { "label-width": "120px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "上传客服图片" } },
                  [
                    _c("upload-picture", {
                      attrs: {
                        limit: 1000000,
                        isCustomer: 1,
                        list: _vm.fileList,
                      },
                      on: { changeImage: _vm.changeImage },
                    }),
                    _c("div", { staticClass: "messageI" }, [
                      _vm._v(
                        " 图片尺寸：建议上传750px*1334px，每张上传大小不得超过5M,支持jpg、jpeg、png格式 "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "显示二维码方式" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "232px" },
                      attrs: { size: "small" },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "bottom-but", staticStyle: { display: "flex" } },
        [
          _c(
            "el-button",
            { attrs: { type: "info" }, on: { click: _vm.back } },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }